import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import PlaceholderPage from '../components/ui/PlaceholderPage';
import LoginPage from '../pages/LoginPage';
import RequiredPasswordChangePage from '../pages/RequiredPasswordChangePage';
import ProfileSettingsPage from '../pages/ProfileSettingsPage';
import RegisterPage from '../pages/RegisterPage';
import RequestTenantPage from '../pages/RequestTenantPage';
import ClientDashboard from '../pages/dashboards/ClientDashboard';
import SalonManagerDashboard from '../pages/dashboards/SalonManagerDashboard';
import BranchGalleryPage from '../pages/salon/BranchGalleryPage';
import SalonBranchesPage from '../pages/salon/SalonBranchesPage';
import SalonSettingsPage from '../pages/salon/SalonSettingsPage';
import SalonServicesPage from '../pages/salon/SalonServicesPage';
import SalonAppointmentsPage from '../pages/salon/SalonAppointmentsPage';
import ClientBookPage from '../pages/client/ClientBookPage';
import ClientAppointmentsPage from '../pages/client/ClientAppointmentsPage';
import CartPage from '../pages/client/CartPage';
import CheckoutPage from '../pages/client/CheckoutPage';
import ClientOrdersPage from '../pages/client/ClientOrdersPage';
import MarketplacePage from '../pages/marketplace/MarketplacePage';
import ProductDetailPage from '../pages/marketplace/ProductDetailPage';
import OfferDetailPage from '../pages/marketplace/OfferDetailPage';
import SalonProductsPage from '../pages/salon/SalonProductsPage';
import SalonOrdersPage from '../pages/salon/SalonOrdersPage';
import SalonInventoryPage from '../pages/salon/SalonInventoryPage';
import SalonAnalyticsPage from '../pages/salon/SalonAnalyticsPage';
import SalonStaffPage from '../pages/salon/SalonStaffPage';
import StaffPerformancePage from '../pages/salon/StaffPerformancePage';
import SalonPosPage from '../pages/salon/SalonPosPage';
import PosLayout from '../components/layout/PosLayout';
import SalonActivityLogsPage from '../pages/salon/SalonActivityLogsPage';
import SalonCampaignsPage from '../pages/salon/SalonCampaignsPage';
import SalonReviewsPage from '../pages/salon/SalonReviewsPage';
import ClientBookmarksPage from '../pages/client/ClientBookmarksPage';
import ClientHistoryPage from '../pages/client/ClientHistoryPage';
import ClientReviewsPage from '../pages/client/ClientReviewsPage';
import ExplorePage from '../pages/explore/ExplorePage';
import SalonProfilePage from '../pages/explore/SalonProfilePage';
import AnalyticsRoute from './AnalyticsRoute';
import SalonStaffDashboard from '../pages/dashboards/SalonStaffDashboard';
import AdminActivityLogsPage from '../pages/admin/AdminActivityLogsPage';
import AdminDashboardPage from '../pages/admin/AdminDashboardPage';
import AdminTenantsPage from '../pages/admin/AdminTenantsPage';
import AdminPendingStaffPage from '../pages/admin/AdminPendingStaffPage';
import AdminUsersPage from '../pages/admin/AdminUsersPage';
import PublicHome from './PublicHome';
import ProtectedRoute from './ProtectedRoute';
import RegisterStaffPage from '../pages/RegisterStaffPage';
import StaffPendingApprovalPage from '../pages/StaffPendingApprovalPage';
import StaffRegistrationRejectedPage from '../pages/StaffRegistrationRejectedPage';
import StaffActiveRoute from './StaffActiveRoute';
import RoleRoute from './RoleRoute';
import SalonTenantRoute from './SalonTenantRoute';
import NotificationsPage from '../pages/NotificationsPage';
import NotFoundPage from '../pages/NotFoundPage';
import ForbiddenPage from '../pages/ForbiddenPage';
import PosRoute from './PosRoute';

const stub = (title) => <PlaceholderPage title={title} description="Coming soon." />;

const AppRoutes = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<PublicHome />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/register-staff" element={<RegisterStaffPage />} />
      <Route path="/request-tenant" element={<RequestTenantPage />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/marketplace/offers/:campaignId" element={<OfferDetailPage />} />
      <Route path="/marketplace/products/:productId" element={<ProductDetailPage />} />
      <Route path="/book" element={<ClientBookPage />} />
      <Route path="/explore" element={<ExplorePage />} />
      <Route path="/explore/:tenantId" element={<SalonProfilePage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/required-password-change" element={<RequiredPasswordChangePage />} />
        <Route path="/staff/pending-approval" element={<StaffPendingApprovalPage />} />
        <Route path="/staff/registration-rejected" element={<StaffRegistrationRejectedPage />} />

          <Route element={<PosRoute />}>
            <Route element={<PosLayout />}>
              <Route path="/salon/pos" element={<SalonPosPage />} />
            </Route>
          </Route>

        <Route element={<AppLayout />}>
          <Route path="/settings/profile" element={<ProfileSettingsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/403" element={<ForbiddenPage />} />

          <Route element={<RoleRoute roles={['SUPER_ADMIN']} />}>
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/tenants" element={<AdminTenantsPage />} />
            <Route path="/admin/staff-registrations" element={<AdminPendingStaffPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/activity-logs" element={<AdminActivityLogsPage />} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          </Route>

          <Route element={<RoleRoute roles={['SALON_MANAGER', 'SUPER_ADMIN']} />}>
            <Route element={<SalonTenantRoute />}>
              <Route path="/salon/dashboard" element={<SalonManagerDashboard />} />
              <Route path="/salon/settings" element={<SalonSettingsPage />} />
              <Route path="/salon/branches" element={<SalonBranchesPage />} />
              <Route path="/salon/branches/:branchId/gallery" element={<BranchGalleryPage />} />
              <Route path="/salon/services" element={<SalonServicesPage />} />
              <Route path="/salon/appointments" element={<SalonAppointmentsPage />} />
              <Route path="/salon/staff" element={<SalonStaffPage />} />
              <Route path="/salon/staff-performance" element={<StaffPerformancePage />} />
              <Route path="/salon/activity-logs" element={<SalonActivityLogsPage />} />
              <Route path="/salon/products" element={<SalonProductsPage />} />
              <Route path="/salon/orders" element={<SalonOrdersPage />} />
              <Route path="/salon/inventory" element={<SalonInventoryPage />} />
              <Route path="/salon/campaigns" element={<SalonCampaignsPage />} />
              <Route path="/salon/reviews" element={<SalonReviewsPage />} />
              <Route path="/salon" element={<Navigate to="/salon/dashboard" replace />} />
            </Route>
          </Route>

          <Route element={<AnalyticsRoute />}>
            <Route path="/salon/analytics" element={<SalonAnalyticsPage />} />
            <Route path="/staff/analytics" element={<SalonAnalyticsPage />} />
          </Route>

          <Route element={<RoleRoute roles={['SALON_STAFF']} />}>
            <Route element={<StaffActiveRoute />}>
              <Route path="/staff/dashboard" element={<SalonStaffDashboard />} />
              <Route path="/staff/appointments" element={<SalonAppointmentsPage />} />
              <Route path="/staff/services" element={<SalonServicesPage />} />
              <Route path="/staff/orders" element={<SalonOrdersPage />} />
              <Route path="/staff/clients" element={stub('Clients')} />
              <Route path="/staff" element={<Navigate to="/staff/dashboard" replace />} />
            </Route>
          </Route>

          <Route element={<RoleRoute roles={['CLIENT']} />}>
            <Route path="/client/dashboard" element={<ClientDashboard />} />
            <Route path="/client/book" element={<Navigate to="/book" replace />} />
            <Route path="/client/appointments" element={<ClientAppointmentsPage />} />
            <Route path="/client/cart" element={<CartPage />} />
            <Route path="/client/checkout" element={<CheckoutPage />} />
            <Route path="/client/orders" element={<ClientOrdersPage />} />
            <Route path="/client/bookmarks" element={<ClientBookmarksPage />} />
            <Route path="/client/history" element={<ClientHistoryPage />} />
            <Route path="/client/reviews" element={<ClientReviewsPage />} />
            <Route path="/client/profile" element={<Navigate to="/settings/profile" replace />} />
            <Route path="/client" element={<Navigate to="/client/dashboard" replace />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
